import { initialUser } from '../../const/store';
import { User } from '../../types';

export interface UserState {
  data: User;
}

export interface TutorialState {
  isActive: boolean;
}

export interface GlobalState {
  user: UserState;
  refreshPage: number;
  tutorial: TutorialState;
}

export const initialState = {
  user: { data: initialUser },
  refreshPage: 0,
  tutorial: { isActive: false, activeStep: null },
} as GlobalState;
